import React from 'react';

import Rodal from 'rodal';
import cx from 'classnames';
import 'rodal/lib/rodal.css';
import { MODAL, MODAL_CONTAINER, CLOSE_ICON } from '../styles/baseModal';
import Icon from '../../Icon';
import { SIZES } from '../constants/Sizes';





















const BaseModal = ({
  visible,
  onClose,
  children,
  className,
  styles,
  isFullWidth,
  closeOnEsc = true,
  closeMaskOnClick = true,
  showHeaderCloseButton = true,
  size = '',
  mediumWidth,
  minWidth,
  isAutoWidth = true
}) =>
<Rodal
  visible={visible}
  onClose={onClose}
  closeOnEsc={closeOnEsc}
  closeMaskOnClick={closeMaskOnClick}
  showCloseButton={false}
  className={cx(
    MODAL_CONTAINER({
      isFullWidth,
      mediumWidth,
      minWidth,
      isAutoWidth
    }),
    {
      [`base-modal--${SIZES[size]}`]: size
    }
  )}>

    <div className={cx(MODAL(styles), 'modal', className)}>
      {showHeaderCloseButton ?
    <Icon
      clickable
      className={cx(CLOSE_ICON, 'modal-close-icon')}
      name="close"
      onClick={onClose}
      color="regent"
      size={15}
      hoverColor="denim" /> :

    null}
      {children}
    </div>
  </Rodal>;


export default BaseModal;